import { nextTick, ref } from 'vue'

type FocusableTextarea = { focus: () => void }

export function useChatInputFocus() {
	const inputRef = ref<FocusableTextarea | null>(null)

	const focusSync = () => {
		inputRef.value?.focus()
	}

	const focusAsync = async () => {
		await nextTick()
		if (!inputRef.value) await nextTick()
		inputRef.value?.focus()
	}

	return { inputRef, focusSync, focusAsync }
}
